import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import LZString from 'lz-string';
import PageRenderer from '../components/core/PageRenderer';
import { useApiDataHook } from '../global-hooks';
import { Loading } from '../components';
import { vmRefProcessorApp } from '../global-utils';
import { getCoreSettings } from '../features/boot';
import { emptyArray, emptyNull } from '../shared/misc';

const RemoteComponentsPage = ({ pageParams = emptyNull, resId, ...restProps }) => {
  const location = useLocation();
  const pageUseParams = useParams();
  const [pageApiCall, setPageApiCall] = useState(emptyArray);
  const core = getCoreSettings();

  useEffect(() => {
    setPageApiCall([{
      uiTitle: resId,
      url: '/v1/cms_settings.json',
      body: {
        last_Item_by_uuid: 1,
        uuid: resId, 
        app_id: core.app_ids,
        include_value: 1,
        timestamp: 86400000, // a day
        is_preproduction: 0
      }
    }]);
  }, [resId]);

  const apiDataPage = useApiDataHook(pageApiCall, {
    ...pageParams,
    ...pageUseParams
  },
  location?.search
    ? Object.fromEntries(new URLSearchParams(location.search))
    : {});

  if (apiDataPage?.[resId]?.isLoading) {
    return <Loading />;
  }

  const pageDataStr = LZString.decompressFromBase64(apiDataPage?.[resId]?.data?.[0]?.value);

  const pageData = pageDataStr.length > 100 ? JSON.parse(pageDataStr) : emptyNull;

  // This could have been memorized, if pageData wouldn't be parsed through JSON.parse
  // what creates new obj each render.
  const pageDataVmRefResolved = vmRefProcessorApp.resolve(pageData);

  return (
    <PageRenderer
      urlParams={{
        ...pageParams,
        ...pageUseParams
      }}
      urlSearchParams={
        location?.search
          ? Object.fromEntries(new URLSearchParams(location.search))
          : {}
      }
      {...restProps}
      {...pageDataVmRefResolved}
    />
  );
};

export default RemoteComponentsPage;
